import { Lightbulb } from 'lucide-react'
import { Prose } from '../../components/prose'
import type { WinnerJudge } from '../types'

export interface EvaluationInvestmentThesisProps {
  winnerJudge: WinnerJudge
}

export function EvaluationInvestmentThesis({ winnerJudge }: EvaluationInvestmentThesisProps) {
  return (
    <div
      className="mt-6 rounded-xl border px-6 py-4"
      style={{
        borderColor: `${winnerJudge.color}33`,
        backgroundColor: `${winnerJudge.color}08`,
      }}
    >
      <div className="flex items-center gap-2 text-xs" style={{ color: winnerJudge.color }}>
        <Lightbulb className="size-3.5" />
        <span className="font-medium">
          {winnerJudge.decided ? 'Investment Thesis' : 'Closest to Invest'}
        </span>
        <span style={{ opacity: 0.5 }}>&middot;</span>
        <span style={{ opacity: 0.6 }}>{winnerJudge.persona}</span>
      </div>
      <Prose className="mt-2 text-sm leading-relaxed text-foreground/80">
        {winnerJudge.thesis}
      </Prose>
    </div>
  )
}
